import styled from 'styled-components';

export const List = styled.ul`
  margin-left: 20px;
`;
